import React, { Component } from 'react';
// import { connect } from 'react-redux';

import { Form, InputField, ResetOnSuccess, FormError } from '../form';

import ActivateModalTrigger from '../billing/ActivateModalTrigger';
import AccountLimitsError from '../billing/AccountLimitsError';

import { FormGroup, Button } from 'reactstrap';
// import { FieldArray } from 'react-final-form-arrays';

// import classNames from 'classnames';

class ProfileForm extends Component {
  render () {
    const { onSubmit, onSuccess, onFail, resetOnSuccess, initialValues, submitValue } = this.props
    
    return (
      <Form
        {...{onSubmit, onSuccess, onFail, resetOnSuccess}}
        initialValues={ (initialValues || {}) }
        render={({ submitError, handleSubmit, submitting, pristine, values, form:{reset, mutators: { push, pop }} }) => (
          
          <form onSubmit={handleSubmit} noValidate={true} name="profile">
            {submitError && <FormError>{submitError}</FormError>}
            
            <ActivateModalTrigger />
            <AccountLimitsError />
            
            
            <FormGroup>
              <InputField meta={{submitting}} name="name" type="text" placeholder="Your name" />
            </FormGroup>
            
            <FormGroup>
              <InputField meta={{submitting}} name="email" type="email" placeholder="Email" />
            </FormGroup>
          
            <FormGroup>
              <InputField meta={{submitting}} name="password" type="password" autoComplete="off" placeholder="New Password" />
            </FormGroup>
            
            
            { values.password && <React.Fragment>
              <FormGroup>
                <InputField meta={{submitting}} name="password_confirmation" autoComplete="off" type="password" placeholder="Confirm New Password" />
              </FormGroup>
            
              <FormGroup>
                <InputField meta={{submitting}} name="current_password" type="password" placeholder="Your current password" />
              </FormGroup>
            </React.Fragment> }
            
            <FormGroup>
              <Button
                color="primary"
                type="submit"
                block={true}
                className="btn-wide upcase"
                disabled={submitting}>
                { submitValue || 'Save' }
              </Button>
              
            </FormGroup>
            
            <ResetOnSuccess enabled={true} reset={reset} />
            
          </form>
        )}
      />
    )
  };
}
// <pre>{JSON.stringify(values, 0, 2)}</pre>

export default ProfileForm;


// WEBPACK FOOTER //
// ./src/components/Profile/form.js